function handleIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const iframe = entry.target;
      const dataSrc = iframe.getAttribute("data-src");

      if (dataSrc) {
        iframe.src = dataSrc;
        iframe.removeAttribute("data-src");
        observer.unobserve(iframe);
      }
    }
  });
}

const iframes = document.querySelectorAll("iframe[data-src]");
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1,
};

const observer = new IntersectionObserver(handleIntersection, observerOptions);

iframes.forEach((iframe) => {
  observer.observe(iframe);
});
